<div class="dialog-header">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ПИН</mat-label>
      <input matInput [ngModel]="personIdnp" name="personIdnp"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'personIdnp')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['personIdnp']) {
      <div class="field-error">{{ fieldErrors()['personIdnp'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ИНН организации</mat-label>
      <input matInput [ngModel]="organizationInn" name="organizationInn"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'organizationInn')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['organizationInn']) {
      <div class="field-error">{{ fieldErrors()['organizationInn'] }}</div>
    }
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Отмена</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Подписать и распределить
    }
  </button>
</mat-dialog-actions>
